export default __webpack_public_path__ + "static/media/Prateek Vishwakarma.0d8f3cc0.jpg";